import React from "react";
import { useAuth } from "../hooks/use-auth.js";
import { Route, Redirect } from "react-router-dom";
import PropTypes from "prop-types";

/**
 * A route only a super-administrator can open. Hiding the navigation entry
 * keeps the page out of the way; this keeps it from being reached by typing the
 * URL. The callables behind these pages enforce the same claim server-side --
 * this guard is what stops an empty shell rendering before they refuse.
 */
function SuperAdminRoute({ children, render, ...rest }) {
  const [auth] = useAuth();

  const handleRender = (renderProps) => {
    const { location } = renderProps;

    if (!auth.user) {
      return (
        <Redirect to={{ pathname: "/sign-in", state: { from: location } }} />
      );
    }

    if (!auth.user.claims?.isSuperAdmin) {
      return <Redirect to={{ pathname: "/" }} />;
    }

    if (render) {
      return render(renderProps);
    }

    return children;
  };

  return <Route {...rest} render={handleRender} />;
}

SuperAdminRoute.propTypes = {
  children: PropTypes.any,
  render: PropTypes.func,
};

export default SuperAdminRoute;
